import {
  Dispatch,
  SetStateAction,
  createContext,
  useContext,
  useState
} from 'react';

type SidebarContextType = {
  sidebar_open: boolean;
  set__sidebar_open: Dispatch<SetStateAction<boolean>>;
  open_sidebar: () => void;
  close_sidebar: () => void;
};

export const SidebarContext = createContext<SidebarContextType | undefined>(
  undefined
);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (context === undefined) {
    throw new Error(`useSidebar must be used within a SidebarContextProvider.`);
  }
  return context;
};

export interface Props {
  [propName: string]: any;
}

export const SidebarContextProvider = (props: Props) => {
  const [sidebar_open, set__sidebar_open] = useState(false);

  const close_sidebar = () => set__sidebar_open(false);
  const open_sidebar = () => set__sidebar_open(true);

  const value: SidebarContextType = {
    sidebar_open,
    set__sidebar_open,
    open_sidebar,
    close_sidebar
  };

  return <SidebarContext.Provider value={value} {...props} />;
};
